export default __webpack_public_path__ + "static/media/icon_settings.50209c0f.svg";